import { configureStore } from "@reduxjs/toolkit";
import activityReducer from "./activity/activitySlice";
import authReducer from "./auth/authSlice";
import accountsReducer from "./accounts/accountsSlice";
import licensesReducer from "./licenses/licensesSlice";
import licenseTypesReducer from "./licenseTypes/licenseTypesSlice";
import usersReducer from "./users/usersSlice";
import uiReducer from "./ui/uiSlice";

export const store = configureStore({
	reducer: {
		activity: activityReducer,
		auth: authReducer,
		accounts: accountsReducer,
		licenses: licensesReducer,
		licenseTypes: licenseTypesReducer,
		users: usersReducer,
		ui: uiReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
			},
		}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
